/**
 * LivePreview — превью через ТОТ ЖЕ рендерер, что и прод (mountWidget). Шаблон
 * несёт свой css сам, поэтому ничего грузить не нужно. Переменные пользователя
 * (themeConfig.vars) накладываются рендером поверх css шаблона.
 */
import type { WidgetConfigSource } from '@inbx/shared/schemas';
import { mountWidget, resolveRuntimeConfig } from '@inbx/widget-render';
import { useEffect, useRef } from 'react';

import { type WidgetDraft } from './editor-shell';

export type PreviewState = 'collapsed' | 'notification' | 'expanded' | 'success' | 'offline';

interface Props {
  draft: WidgetDraft;
  state: PreviewState;
}

export function LivePreview({ draft, state }: Props): JSX.Element {
  const hostRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const host = hostRef.current;
    if (!host) return;
    const source: WidgetConfigSource = {
      widgetId: 'preview',
      publicKey: 'preview',
      type: draft.type,
      themeConfig: draft.themeConfig,
      contentConfig: draft.contentConfig,
      behaviorConfig: draft.behaviorConfig,
      mediaConfig: draft.mediaConfig,
      customCssUrl: draft.customCssUrl,
    };
    const ctrl = mountWidget({
      host,
      config: resolveRuntimeConfig(source),
      cssHref: '/api/widget-templates.css',
      preview: true,
      state,
      demo: true,
      openInitially: state === 'expanded' || state === 'offline',
      initialSuccess: state === 'success',
      handlers: { onSubmit: async () => undefined },
    });
    return () => ctrl.destroy();
  }, [draft, state]);

  return <div className="inbx-preview-host" ref={hostRef} />;
}
